import React from 'react';

export function SendIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.251 15.7729C17.841 15.7729 17.501 15.4329 17.501 15.0229V6.56293L4.78098 19.2829C4.63098 19.4329 4.44098 19.5029 4.25097 19.5029C4.06098 19.5029 3.87097 19.4329 3.72097 19.2829C3.43097 18.9929 3.43097 18.5129 3.72097 18.2229L16.441 5.50293H7.98098C7.57097 5.50293 7.23098 5.16293 7.23098 4.75293C7.23098 4.34293 7.57097 4.00293 7.98098 4.00293H18.251C18.351 4.00293 18.441 4.02293 18.541 4.06293C18.721 4.13293 18.871 4.28293 18.941 4.46293C18.981 4.56293 19.001 4.65293 19.001 4.75293V15.0229C19.001 15.4329 18.661 15.7729 18.251 15.7729Z"
        fill="#1F2A37"
      />
    </svg>
  );
}
